// Contentsquare documentation: https://docs.contentsquare.com/en/web/sending-dynamic-vars/
const pushToContentsquare = function (key, info) {
  window.top._uxa = window.top._uxa || [];
  window.top._uxa.push([key, info]);
}

const pushDynamicVariable = function (info) {
  pushToContentsquare('trackDynamicVariable', info);
}

const pushDestinationSearch = function (value) {
  pushToContentsquare('trackDynamicVariable', {key: 'Destination - Search Box Country', value: value})
}

export {
  pushDynamicVariable,
  pushDestinationSearch,
}

export default pushToContentsquare;
